module.exports = __webpack_public_path__ + "static/media/work6.8ee2e00c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/work6.png
// module id = 87
// module chunks = 0